const ERROR_TEXT = 'Error: '
export const ERR_EXCHANGE_ORDER_BOOK_FETCH =
  ERROR_TEXT + 'Cannot get orders book from the Exchange.'
export const ERR_EXCHANGE_WS_TICKER_FETCH =
  ERROR_TEXT + 'Cannot connect to price ticker in the Exchange.'
export const ERR_EXCHANGE_WS_CANDLE_FETCH =
  ERROR_TEXT + 'Cannot connect to candle in the Exchange.'
export const ERR_EXCHANGE_WS_ORDERBOOK_FETCH =
  ERROR_TEXT + 'Cannot connect to orderbook in the Exchange.'
